<div class="sh-compact-navigation">
  @if (showApplicationInformation) {
    <div class="application-information">
      <p>{{ applicationName }}</p>
      <p>{{ applicationEnvironment}}</p>
      <p>{{ applicationVersion }}</p>
    </div>
  }
  @if (mainActionItem) {
    <sh-compact-navigation-main-action [item]="mainActionItem"></sh-compact-navigation-main-action>
  }
  @if ((primaryNavItems$ | async); as primaryNavItems) {
    <ul
      class="sh-navigation__list"
      (mouseleave)="noneSelected(primaryNavItems, true)"
      (shClickOutside)="noneSelected(primaryNavItems, true)"
      [shClickOutsideFocusEvent]="'mouseenter'"
      >
      @for (item of primaryNavItems; track item.label; let i = $index) {
        <li class="sh-compact-navigation__list__item">
          <sh-compact-navigation-item [item]="item" (selected)="selectionChanged($event, i, primaryNavItems, true)"></sh-compact-navigation-item>
        </li>
      }
    </ul>
  }
  @if ((secondaryNavItems$ | async); as secondaryNavItems) {
    <ul
      class="sh-navigation__list -sh-to-bottom"
      (mouseleave)="noneSelected(primaryNavItems, true)"
      (shClickOutside)="noneSelected(secondaryNavItems, false)"
      [shClickOutsideFocusEvent]="'mouseenter'"
      >
      @for (item of secondaryNavItems; track $index; let i = $index) {
        <li class="sh-compact-navigation__list__item">
          <sh-compact-navigation-item
            [item]="item"
            [openDropmenuAbove]="true"
            (selected)="selectionChanged($event, i, secondaryNavItems, false)"
          ></sh-compact-navigation-item>
        </li>
      }
    </ul>
  }
</div>
